export const TOGGLE_LEGAL_MESSAGE = 'TOGGLE_LEGAL_MESSAGE';
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';
export const TOGGLE_NEW_PRODUCT_MODAL = 'TOGGLE_NEW_PRODUCT_MODAL';
export const TOGGLE_USER_INVITATION_MODAL = 'TOGGLE_USER_INVITATION_MODAL';
export const SET_NEWS_BANNER = 'SET_NEWS_BANNER';
export const TOGGLE_DELETE_CONFIRMATION = 'TOGGLE_DELETE_CONFIRMATION';



// WEBPACK FOOTER //
// ./src/store/modules/ui/types.ts